<div class="grid justify-content-center">
  <div class="col-12 py-0 my-0">
    <p-messages class="py-0 my-0" severity="info">
      <ng-template pTemplate>
        <span
          >Custom boundary cannot cross the borders of {{ this.country }}.</span
        >

        <button
          (click)="help = !help"
          class="p-button-outlined ml-auto"
          icon="pi pi-question-circle"
          iconPos="left"
          label="Help"
          pButton
          style="width: auto"
          type="button"
        ></button>
      </ng-template>
    </p-messages>
  </div>

  <ng-container *ngIf="this.country == 'Zambia'">
    <p-dropdown
      [(ngModel)]="selectedCountryArea"
      [options]="countryAreas"
      appendTo="body"
      class="col-12 md:col-9"
      optionLabel="name"
      placeholder="Select an Area"
    >
    </p-dropdown>

    <div class="col-12 md:col-3">
      <p-button
        (click)="setArea(selectedCountryArea.points)"
        label="Set Area"
      ></p-button>
    </div>
  </ng-container>
  <div class="grid formgrid">
    <div class="field md:col-5">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">Long</span>
        <input
          [(ngModel)]="userSelectedCoordinates.long"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          class="form-control"
          id="long"
          name="long"
          pInputText
          placeholder="Longitude"
          spellcheck="off"
          type="text"
        />
      </div>
    </div>
    <div class="field md:col-5">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">Lat</span>
        <input
          [(ngModel)]="userSelectedCoordinates.lat"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          class="form-control"
          id="lat"
          name="lat"
          pInputText
          placeholder="Latitude"
          spellcheck="off"
          type="text"
        />
      </div>
    </div>
    <div class="field md:col-2">
      <p-button
        (click)="findCoordinates()"
        icon="pi pi-search"
        iconPos="left"
        styleClass="p-button-outlined"
      ></p-button>
    </div>
  </div>

  <div class="col-12">
    <!-- TODO: We need a single map component. -->
    <boma-update-location></boma-update-location>

    <!--    <agm-map-->
    <!--      (mapReady)="onMapReady($event)"-->
    <!--      [controlSize]="27"-->
    <!--      [fullscreenControl]="true"-->
    <!--      [latitude]="lat"-->
    <!--      [longitude]="lng"-->
    <!--      [mapTypeControl]="true"-->
    <!--      [zoom]="zoomLevel"-->
    <!--      mapTypeId="hybrid"-->
    <!--      style="width: 100%;"-->
    <!--    >-->
    <!--      <ng-container *ngIf="markers?.length">-->
    <!--        <agm-marker-->
    <!--          *ngFor="let marker of markers"-->
    <!--          [iconUrl]="marker.icon || markerPlain"-->
    <!--          [latitude]="marker.lat"-->
    <!--          [longitude]="marker.long"-->
    <!--        >-->
    <!--          <agm-info-window #infoWindow>-->
    <!--            {{ marker.label }}-->
    <!--          </agm-info-window>-->
    <!--        </agm-marker>-->
    <!--      </ng-container>-->
    <!--    </agm-map>-->
  </div>
  <div class="col-12">
    <div class="flex align-items-center justify-content-between">
      <!-- This div is required to not full with the button shrug -->
      <div class="grid justify-content-center">
        <div class="flex align-items-center justify-content-between">
          <p-button
            (click)="help = !help"
            class="ml-2"
            icon="pi pi-question-circle"
            iconPos="left"
          ></p-button>

          <p-button
            (click)="setCurrentPosition()"
            class="ml-2"
            icon="material-icons-round mi-location-searching"
            iconPos="left"
            label="My Location"
          ></p-button>
        </div>
      </div>
      <div class="grid justify-content-center">
        <div class="flex align-items-center justify-content-between">
          <p-button
            (click)="initDrawingManager(this.theMap, true)"
            [disabled]="isDrawing"
            class="ml-2"
            icon="material-icons-round mi-edit-location"
            iconPos="left"
            label="Edit"
          ></p-button>

          <p-button
            (click)="initDrawingManager(this.theMap)"
            [disabled]="isDrawing"
            class="ml-2"
            icon="material-icons-round mi-edit-location-alt"
            iconPos="left"
            label="New"
          ></p-button>

          <p-button
            (click)="saveTheMap()"
            *ngIf="showSave"
            [disabled]="!editedMap"
            class="ml-2"
            icon="material-icons-round mi-save"
            iconPos="left"
            label="Save"
          ></p-button>
        </div>
      </div>

      <!--      <p-button-->
      <!--        (click)='saveTheMap()'-->
      <!--        *ngIf='showSave'-->
      <!--        [disabled]='!editedMap'-->
      <!--        class='ml-2'-->
      <!--        label='Save'-->
      <!--      ></p-button>-->

      <!--      <p-button-->
      <!--        (click)='clearSelection()'-->

      <!--        class='ml-2'-->
      <!--        label='Clear'-->
      <!--      ></p-button>-->
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="help"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [showHeader]="true"
  [style]="{ width: '450px' }"
  header=" "
>
  <p-carousel
    [circular]="true"
    [numScroll]="1"
    [numVisible]="1"
    [value]="helpSlides"
  >
    <ng-template let-slide pTemplate="item">
      <div class="slide-item text-center pt-2">
        <ng-container *ngIf="slide.video">
          <div [innerHTML]="slide.video"></div>
        </ng-container>
        <img [src]="slide.image" />
        <h3>{{ slide.title }}</h3>
        <div [innerHtml]="slide.text"></div>
      </div>
    </ng-template>
  </p-carousel>
</p-dialog>
